import * as React from "react";
import { observable, action } from "mobx";
import { observer, inject } from "mobx-react";
import SeekerStore from "../../../stores/seekerStore";
import { CCLCExperience } from "../../../models/profile";
import { CCLCReq } from "../../../models/opportunity";
import { EmptyESId, ExperienceType, CCLCFieldMask, CCLCRefType, CertValidation } from "../../../models/enums";
import { IEditCCLCLocalization, IAddActivityLocalization, IPrereqLocalization, IValidationLocalization } from "../../../models/localization";
import DescriptionEditor from "../descriptionEditor";
import { Grid, Row, Col } from "react-flexbox-grid";
import TextField from "material-ui/TextField";
import { MenuItem } from "material-ui/Menu";
import List from "material-ui/List";
import Paper from "material-ui/Paper";
import { InputLabel } from "material-ui/Input";
import CheckBox from "material-ui/Checkbox";
import { FormControl, FormControlLabel } from "material-ui/Form";
import Select from "material-ui/Select";
import { ValidatorForm, TextValidator, SelectValidator } from "react-material-ui-form-validator";
import * as s from "./ccls.css";

@observer
class ExperienceTypePicker extends React.Component<{ store: SeekerStore, exp: CCLCExperience }, {}> {
  constructor(props: any) {
    super(props);
  }
  @action onChangeProperty = (evt: any): void => {
    const nm: string = evt.target.id || evt.target.name;
    this.props.exp[nm] = evt.target.value;
    this.props.store.profileStore.setValidationMode(CertValidation.None);
  }

  render(): JSX.Element {
    const actLocal: IAddActivityLocalization = this.props.store.localization.fields.addActivity;
    const items: JSX.Element[] = [];
    let i: number = 0;
    for (let item in CCLCRefType) {
      const num: number = Number(item);
      if (!isNaN(num)) {
        const name: string = (num < actLocal.cclcRefType.length) ? actLocal.cclcRefType[num] : CCLCRefType[num];
        items.push(<MenuItem key={i++} value={num}>{name}</MenuItem>)
      }
    }
    return (<FormControl fullWidth>
      <InputLabel htmlFor="type">{actLocal.org}</InputLabel>
      <Select value={this.props.exp.type} onChange={this.onChangeProperty} inputProps={{ name: "type", id: "type" }} onFocus={() => this.props.store.profileStore.clearSuggestedPositions()}>
        {items}
      </Select>
    </FormControl>);
  }
}

@observer
class CredentialPicker extends React.Component<{ store: SeekerStore, exp: CCLCExperience }, {}> {
  constructor(props: any) {
    super(props);
  }
  @action selectCredential = (cred: CCLCReq): void => {
    this.props.exp.cclcId = cred.idHash;
    this.props.exp.title = cred.title;
    this.props.exp.type = cred.type;
    this.props.exp.cclcRef = cred;
    this.props.store.profileStore.clearSuggestedCredentials();
    this.setValidationRule();
  }
  @action setValidationRule = (): void => {
    if ((this.props.exp.cclcRef && (this.props.exp.cclcRef.fields & CCLCFieldMask.ReceiptDate) > 0) && (this.props.exp.cclcRef && (this.props.exp.cclcRef.fields & CCLCFieldMask.ExpireDate) > 0)) {
      this.props.store.profileStore.setValidationMode(CertValidation.FullDate);
    } else if (this.props.exp.cclcRef && (this.props.exp.cclcRef.fields & CCLCFieldMask.ExpireDate) > 0) {
      this.props.store.profileStore.setValidationMode(CertValidation.DateExpired);
    } else if (this.props.exp.cclcRef && (this.props.exp.cclcRef.fields & CCLCFieldMask.ReceiptDate) > 0) {
      this.props.store.profileStore.setValidationMode(CertValidation.DateRecieved);
    } else {
      this.props.store.profileStore.setValidationMode(CertValidation.None);
    }
  }

  render(): JSX.Element {
    const items: JSX.Element[] = [];
    this.props.store.profileStore.suggestedCredentials.map((cred: CCLCReq, i: number): void => {
      items.push(<MenuItem key={i} value={cred.idHash} onClick={() => this.selectCredential(cred)}>{cred.title}</MenuItem>);
    });
    if (items.length === 0) {
      return null;
    }
    return (<Row><Col xs={12} sm={6}>
      <Paper style={{ marginTop: "-15px" }}>
      <List>{items}</List>
      </Paper>
    </Col></Row>);
  }
}
@inject("store") @observer
export default class CCLCEditor extends React.Component<{ store: SeekerStore, exp: CCLCExperience, name?: string }, {}> {
  @observable received: string;
  @observable expires: string;
  @observable recDateValid: boolean;
  @observable expDateValid: boolean;
  constructor(props: any) {
    super(props);
    this.recDateValid = this.expDateValid = false;
  }
  @action componentWillMount(): void {
    if (this.props.name) {
      this.onChangeTitle({ target: { value: this.props.name } }, true);
    }
    if (this.props.exp.received) {
      this.received = this.toDateString(this.props.exp.received);
    }
    if (this.props.exp.expires) {
      this.expires = this.toDateString(this.props.exp.expires);
    }
    ValidatorForm.addValidationRule('isDate', (value) => {

      if (!value.match(/^(19|20)\d\d[\-\/](0[1-9]|1[012])[\-\/](0[1-9]|[12][0-9]|3[01])$/)) {
        this.props.store.profileStore.setDateIsValid(false);
        return false;
      }
      if (event.target["name"] === "received") {
        this.recDateValid = true;
      }
      if (event.target["name"] === "expires") {
        this.expDateValid = true;
      }
      this.handleSubmit();
      return true;   
    });
  }

  @action onChangeScore = (score: number): void => {
    this.props.exp.score = score;
  }
  @action onChangeReceiptDate = (event: { target: HTMLInputElement; }): void => {
    this.received = event.target.value;
    this.props.exp.received = new Date(event.target.value);
  }
  @action onChangeExpiredDate = (event: { target: HTMLInputElement; }): void => {
    this.expires = event.target.value;
    this.props.exp.expires = new Date(event.target.value);
  }
  @action onChangeProperty = (evt: any): void => {
    const fld: string = evt.target.id || evt.target.name;
    this.props.exp[fld] = evt.target.value;
  }
  @action setAcceptance = (chk: boolean): void => {

  }
  @action handleSubmit = (): void => {

    if ((this.props.exp.cclcRef && (this.props.exp.cclcRef.fields & CCLCFieldMask.ReceiptDate) > 0) && (this.props.exp.cclcRef && (this.props.exp.cclcRef.fields & CCLCFieldMask.ExpireDate) > 0)) {
      if (this.recDateValid && this.expDateValid) {
        this.props.store.profileStore.setDateIsValid(true);
      }
    } else if (this.props.exp.cclcRef && (this.props.exp.cclcRef.fields & CCLCFieldMask.ExpireDate) > 0) {
      if (this.expDateValid) {
        this.props.store.profileStore.setDateIsValid(true);
      }
    } else if (this.props.exp.cclcRef && (this.props.exp.cclcRef.fields & CCLCFieldMask.ReceiptDate) > 0) {
      if (this.recDateValid) {
        this.props.store.profileStore.setDateIsValid(true);
      }
    }
  }

  @action onChangeTitle = (e: any, autoSelect:boolean = false): void => {
    this.props.exp.title = e.target.value;
    this.props.exp.cclcId = null;
    this.props.store.profileStore.clearSuggestedCredentials();
    if (this.props.exp.title.length >= 3) {
      this.props.store.profileStore.getSuggestedCredentials(this.props.exp.title, autoSelect);
    }
  }
  clearFocus = (): void => {
    this.props.store.profileStore.clearSuggestedCredentials();
  }
  private toDateString(date?: Date): string {
    let d: Date = new Date();
    if (date) {
      d = new Date(date.valueOf());
    }
    let mn: string = (d.getMonth() + 1).toString();
    if (mn.length === 1) {
      mn = "0" + mn;
    }
    let dt:string = d.getDate().toString();
    if (dt.length === 1) {
      dt = "0" + dt;
    }
    return `${d.getFullYear()}-${mn}-${dt}`;
  }
  render(): JSX.Element {
    const editLocal: IEditCCLCLocalization = this.props.store.localization.fields.editCCLC;
    const actLocal: IAddActivityLocalization = this.props.store.localization.fields.addActivity;
    const prereqLocal: IPrereqLocalization = this.props.store.localization.fields.prereq;
    const validationLocal: IValidationLocalization = this.props.store.localization.fields.validation;
    const isBound: boolean = this.props.exp.cclcId !== null && this.props.exp.cclcId !== EmptyESId && this.props.exp.cclcRef !== null;
    const checked: any = { color: "#5B6770" };
    const isLicError:boolean = this.props.exp.cclcRef && (this.props.exp.cclcRef.reqFields & CCLCFieldMask.Number) > 0 && !this.props.exp.number;
    let licLabel:string  = prereqLocal.number;
    if (isLicError) {
      licLabel += ` (${this.props.store.localization.fields.required})`;
    }
    const isScoreError:boolean = this.props.exp.cclcRef && (this.props.exp.cclcRef.reqFields & CCLCFieldMask.Score) > 0 && !this.props.exp.score;
    let scoreLabel:string = prereqLocal.score;
    if (isScoreError) {
      scoreLabel += ` (${this.props.store.localization.fields.required})`;
    }

    return (<div>
      <Row className={s.row}>
        <Col xs={12} sm={6} xl={4} className={s.col}>
          <TextField label={editLocal.title} value={this.props.exp.title} onChange={this.onChangeTitle} onBlur={() => setTimeout(this.clearFocus, 500)} id="title" fullWidth />
        </Col>
        {!isBound && this.props.exp.title.length > 0 && <Col xs={12} sm={6} xlOffset={1} xl={4} className={s.col} >
          <ExperienceTypePicker store={this.props.store} exp={this.props.exp} />
        </Col>}
      </Row>
      <CredentialPicker store={this.props.store} exp={this.props.exp} />
      <Row>
        {this.props.exp.cclcRef && (this.props.exp.cclcRef.fields & CCLCFieldMask.Issuer) > 0 && <Col xs={12} sm={6} xl={4}>
          <TextField label={prereqLocal.issuer} value={this.props.exp.issuer}
            onChange={this.onChangeProperty} id="issuer" fullWidth onFocus={() => this.props.store.profileStore.clearSuggestedCredentials()} />
        </Col>}
      </Row>
      <Row>
        {this.props.exp.cclcRef && (this.props.exp.cclcRef.fields & CCLCFieldMask.ReceiptDate) > 0 && <Col xs={6} sm={4} md={3} lg={2}>
          <ValidatorForm
            ref="form"
            onSubmit={this.handleSubmit}
            instantValidate={true}>
            <TextValidator
              fullWidth
              name="received"
              id="received"
              label={prereqLocal.receipt}
              type="date"
              validators={['required', 'isDate']}
              errorMessages={[validationLocal.requiredField, validationLocal.dateErrMsg]}
              value={this.received}
              onChange={this.onChangeReceiptDate}
              InputLabelProps={{ shrink: true }}
            />
          </ValidatorForm>    
        </Col>}
        {this.props.exp.cclcRef && (this.props.exp.cclcRef.fields & CCLCFieldMask.ExpireDate) > 0 && <Col xs={6} sm={4} md={3} lg={2}>
          <ValidatorForm
            ref="form"
            onSubmit={this.handleSubmit}
            instantValidate={true}>
            <TextValidator
            fullWidth
            name="expires"
            id="expires"
            label={prereqLocal.expires}
            type="date"
            validators={['required', 'isDate']}
            errorMessages={[validationLocal.requiredField, validationLocal.dateErrMsg]}
            value={this.expires}
            onChange={this.onChangeExpiredDate}
            InputLabelProps={{
              shrink: true,
            }} />
          </ValidatorForm>
        </Col>}
      </Row>
      <Row>
        {this.props.exp.cclcRef && (this.props.exp.cclcRef.fields & CCLCFieldMask.Number) > 0 && <Col xs={12} sm={3}>
          <TextField label={licLabel} value={this.props.exp.number} onChange={this.onChangeProperty} id="number" fullWidth
            error={isLicError} />
        </Col>}
        {this.props.exp.cclcRef && (this.props.exp.cclcRef.fields & CCLCFieldMask.Score) > 0 && <Col xs={12} sm={3}>
          <TextField label={scoreLabel} value={this.props.exp.score}
            onChange={(e: any) => this.onChangeScore(parseFloat(e.target.value))}
            error={isScoreError} />
          </Col>}
      </Row>
      <Row className={s.row}>
        <Col xs={12} xl={9}>
          {!isBound && this.props.exp.title.length > 0 && !this.props.exp.cclcRef && <DescriptionEditor store={this.props.store} descriptor={this.props.exp} />}
          </Col>
        </Row>
    </div>);
  }
}



// WEBPACK FOOTER //
// ./src/components/profile/cclcEditor/index.tsx